import { get } from 'lodash'

export interface CSV {
  data: string
}

export interface Response {
  data: Blob | any
}

export const downloadCSV = (
  response: CSV,
  fallbackFilename: string = 'download.csv',
) => {
  const blob = new Blob([response.data], {
    type: 'data:text/csv;charset=utf-8;',
  })
  const url = URL.createObjectURL(blob)

  const contentDisposition = get(response, 'headers.content-disposition', '')
  // Regex searches for /filename=/, and optionally, a pair of single or double quotes
  const filenameFromHeader = contentDisposition.match(
    /filename[^;\n]*=\s*(UTF-\d['\"]*)?((['\"]).*?[.]$\2|[^;\n]*)?/,
  )?.[2]

  const filename = filenameFromHeader || fallbackFilename

  // Create a link to download it
  const pom = document.createElement('a')
  pom.href = url
  pom.setAttribute('download', filename)
  pom.click()
}

export const downloadExcel = (response: Response, fileName: string) => {
  let blob

  if (response.data instanceof Blob) {
    blob = response.data
  } else {
    blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet; charset=binary',
    })
  }

  const url = URL.createObjectURL(blob)

  // Create a link to download it
  const pom = document.createElement('a')
  pom.href = url
  pom.setAttribute('download', fileName)
  pom.click()
}
